import { BrowserRouter, Routes, Route } from "react-router-dom";

import ProtectedRoute from "./ProtectedRoute";
import Registration from "./pages/registration/registration";
import LogIn from "./pages/login/login";
import Deposit from "./pages/deposit/deposit";
import Payment from "./pages/payment/payment";
import PersonalInfo from "./pages/personal-information/personal-information";
import TransactionHistory from "./pages/transaction-history/transaction-history";
import "./App.css";
import "./themes.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Публичные маршруты */}
          <Route path="/" index element={<LogIn />} />
          <Route path="register" element={<Registration />} />

          {/* Защищенные маршруты */}
          <Route
            path="/deposit"
            element={
              <ProtectedRoute>
                <Deposit />
              </ProtectedRoute>
            }
          />
          <Route
            path="payment"
            element={
              <ProtectedRoute>
                <Payment />
              </ProtectedRoute>
            }
          />
          <Route
            path="personal-info"
            element={
              <ProtectedRoute>
                <PersonalInfo />
              </ProtectedRoute>
            }
          />
          <Route
            path="transaction-history"
            element={
              <ProtectedRoute>
                <TransactionHistory />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
